// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"style_tooltip__aAbZS","tooltiptext-block":"style_tooltiptext-block__SQsbG","tooltiptext":"style_tooltiptext__vuQGY","tooltiptext-bn":"style_tooltiptext-bn__Aqx4D"};